import React from 'react';

import { Box } from '@/box';

interface MembershipDiscountTagProps {
  discount: string;
  backgroundColor?: string;
  textColor?: string;
}

export const MembershipDiscountTag = ({
  discount,
  backgroundColor = '#FFC940',
  textColor = '#272729',
}: MembershipDiscountTagProps) => {
  return (
    <Box
      css={{
        position: 'relative',
        display: 'inline-block',
        width: 68,
        height: 28,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="68"
        height="28"
        viewBox="0 0 68 28"
        fill="none"
      >
        <path
          d="M4.44336 0.25H63.5566C63.6945 0.250229 63.8512 0.35381 63.9355 0.553711L63.9668 0.645508C64.4516 2.43164 65.5928 3.85772 67.0557 4.39551L67.3525 4.49121C67.5685 4.55109 67.7498 4.76498 67.75 5.03418V22.3789C67.7499 22.4679 67.6885 22.4996 67.6631 22.5C65.4432 22.5 63.6508 24.4751 63.167 27.0293L63.124 27.2783C63.0772 27.582 62.8736 27.75 62.6992 27.75H4.62598C4.47337 27.75 4.29834 27.6213 4.22559 27.3857L4.20117 27.2783C3.86084 25.0665 2.55335 23.2556 0.816406 22.6855L0.647461 22.6348C0.431447 22.5749 0.250086 22.3601 0.25 22.0908V5.03418C0.250075 4.79859 0.388963 4.60537 0.568359 4.52051L0.647461 4.49023C2.1516 4.07293 3.35617 2.73284 3.92676 0.99707L4.03223 0.645508C4.10279 0.385463 4.28573 0.25 4.44336 0.25Z"
          fill={backgroundColor}
          stroke="#272729"
          strokeWidth="0.5"
        />
      </svg>
      <span
        css={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          color: textColor,
          textAlign: 'center',
          fontFamily: 'PP Right Slab',
          fontSize: '14px',
          fontWeight: 300,
          lineHeight: '140%',
          letterSpacing: '0.28px',
          textWrap: 'nowrap',
        }}
      >
        {discount}
      </span>
    </Box>
  );
};
